import { AxiosResponse } from "axios";
import RequestsService from "./requests.service";
import { APIRoutes } from "../http";
import { IResultResponse } from "../models/response/result.model";
import { IBlog } from "../models/blog.model";

export default class BlogService {
  static async create(
    blog: IBlog
  ): Promise<AxiosResponse<IResultResponse<IBlog>>> {
    return RequestsService.postMethod<IResultResponse<IBlog>>(
      APIRoutes.BLOG,
      blog
    );
  }

  static async update(
    blog: IBlog
  ): Promise<AxiosResponse<IResultResponse<IBlog>>> {
    return RequestsService.putMethod<IResultResponse<IBlog>>(
      `${APIRoutes.BLOG}`,
      blog
    );
  }

  static async uploadImage(
    blogId: number,
    file: FormData
  ): Promise<AxiosResponse<IResultResponse<IBlog>>> {
    return RequestsService.putMethod<IResultResponse<IBlog>>(
      `${APIRoutes.BLOG}/uploadImage/${blogId}`,
      file
    );
  }

  static async delete(blogId: number): Promise<AxiosResponse<IResultResponse<any>>> {
    return RequestsService.deleteMethod<IResultResponse<any>>(`${APIRoutes.BLOG}/${blogId}`);
  }
}
